module.exports = __webpack_public_path__ + "assets/f007793ce919cae96a55a5da1c5bf977.png";